<template>
  <div class="investment-form">
    <div class="header">
      Información básica
      <div @click="$emit('openStep')"><span class="mdi mdi-chevron-down"></span></div>
    </div>
    <div class="description">
      Recuerda que tu nombre y apellidos deben de coicidir con tu identificación oficial,
      de lo contrario, el contrato no tendrá validez y tu inversión no podrá ser tomada en cuenta.
    </div>
    <div class="form">
      <label class="label label--half">
        <div class="label-text">
          Nombre
        </div>
        <BaseInput v-model="data.name" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          Primer Apellido
        </div>
        <BaseInput v-model="data.lastName" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          Segundo Apellido
        </div>
        <BaseInput v-model="data.secondLastName" />
      </label>
      <div class="label label--half">
        <div class="label-text">
          Fecha de nacimiento
        </div>
        <datepicker
          v-model="data.birthday"
          initial-view="year"
          :language="es"
          input-class="form-input"
          :use-utc="true"
          :full-month-name="true" />
      </div>
      <label class="label label--half">
        <div class="label-text">
          CURP
        </div>
        <BaseInput v-model="data.curp" />
      </label>
      <label class="label label--half">
        <div class="label-text">
          RFC
        </div>
        <BaseInput v-model="data.rfc" @focus="rfcHasFocus = true" @blur="rfcHasFocus = false"/>
      </label>
      <div class="validation-warning" v-if="data.rfc !== '' && !rfcHasFocus && !rfcValidation">
        El RFC proporcionado no coincide con nuestra validación. Por favor revisa el dato. Si crees
        que hay un error comunicate con nosotros a support@flagship.mx.
      </div>
      <div class="label label--half">
        <div class="label-text">Nacionalidad</div>
        <BaseRadio :options="nationalityOptions" v-model="data.nationality" />
      </div>
    </div>
    <div class="button-wrapper">
      <div class="button" :class="{ disabled: !formFilled }" @click="saveData">
        Siguiente
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import RfcFacil from 'rfc-facil';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

const { mapState, mapActions } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      data: {},
      es,
      nationalityOptions: [
        { text: 'Mexicana', value: 'mexicana' },
        { text: 'Extranjera', value: 'extranjera' },
      ],
      rfcHasFocus: false,
    };
  },
  components: {
    BaseInput,
    BaseRadio,
    Datepicker,
  },
  watch: {
    user() {
      this.data = { ...this.user };
    },
  },
  computed: {
    formFilled() {
      const fields = ['name', 'lastName', 'curp', 'rfc', 'birthday', 'nationality'];
      for (let i = 0; i < fields.length; i += 1) {
        const key = fields[i];
        if (!this.data[key]) {
          return false;
        }
      }
      return this.rfcValidation;
    },
    curpVerification() {
      const re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
      const isCurpValid = this.data.curp.match(re);

      return isCurpValid;
    },
    rfcValidation() {
      const birthdayDate = moment.utc(this.data.birthday);
      const rfcData = {
        name: this.data.name,
        firstLastName: this.data.lastName,
        secondLastName: this.data.secondLastName,
        day: birthdayDate.date(),
        month: birthdayDate.month() + 1,
        year: birthdayDate.year(),
      };
      const calculatedRfc = RfcFacil.forNaturalPerson(rfcData);

      return calculatedRfc === this.data.rfc;
    },
    ...mapState([
      'user',
    ]),
  },
  methods: {
    async saveData() {
      if (this.formFilled) {
        await this.updateUser(this.data);
        this.$emit('next');
      }
    },
    ...mapActions([
      'updateUser',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.investment-form {
  display: flex;
  flex-wrap: wrap;
}
.label {
  width: 100%;
  margin-bottom: 20px;
}
.label--half {
  width: 48%;
}
.label--third {
  width: 30%;
}
.label-text {
  line-height: 18px;
  margin-bottom: 12px;
}
.header {
  width: 100%;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.description {
  margin-bottom: 20px;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1.3rem;
}
.form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
/deep/ .form-input {
  font-size: 15px;
  border: none;
  border: 1px solid #d6d6d8;
  padding: 8px;
  font-family: inherit;
  width: 100%;
  border-radius: 4px;

  &:focus {
    border: 1px solid #3479e9;
  }
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}
.disabled {
  background-color: lighten($color: #3479e9, $amount: 20);
  cursor: not-allowed;
}
.validation-warning {
  color: red;
  line-height: 20px;
  margin-bottom: 14px;
}
</style>
